<fuse-app-lessons-tab
    class="page-layout simple inner-scroll"
    fxFlex
    type="currentUser"
    [hiddenForcedFilters]="forceFilters"
    [urlFilters]="filters"
    [isTypologyFilterAllowed]="isTypologyFilterAllowed"
></fuse-app-lessons-tab>
